export default __webpack_public_path__ + "static/crm-invoicing-balthazaurus-scroll-34ac17defbe685f5d05bfdaedb28811b.gif";